import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { logoutUser } from "../../redux/auth/authSlice";

const InactivityTimeoutHOC = (WrappedComponent, timeoutDuration) => {
  return function WithInactivityTimeout(props) {
    const [inactivityTimer, setInactivityTimer] = useState(null);
    const dispatch = useAppDispatch();
    const startInactivityTimer = () => {
      clearTimeout(inactivityTimer);
      const timerId = setTimeout(logoutNow, timeoutDuration);
      setInactivityTimer(timerId);
    };

    const logoutNow = () => {
      // Your logout logic here
      dispatch( logoutUser());
    };

    useEffect(() => {
      document.addEventListener("mousemove", startInactivityTimer);
      document.addEventListener("keydown", startInactivityTimer);

      return () => {
        document.removeEventListener("mousemove", startInactivityTimer);
        document.removeEventListener("keydown", startInactivityTimer);
        clearTimeout(inactivityTimer);
      };
    }, [inactivityTimer]);

    return <WrappedComponent {...props} />;
  };
};

export default InactivityTimeoutHOC;
